import React, {useState, useEffect, useRef}  from 'react';
import { useDispatch, useSelector } from "react-redux";
import Layout from "../../layout/Layout";

import { useropen } from '../../redux/userInfo';
import { open, close } from '../../redux/popupSlice';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import Input from '../../component/Input';
import Button from '../../component/Button';

import * as APIS from "../../utils/service";
import queryString from 'query-string';


export default function Register0({ navigation }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();

    const { configdata } = useSelector(s => s.configReducer);
    const query = queryString.parse(location.search);
    console.log(query);
    const [reqname, setreqname] = useState(query?.name);   
    const [reqsex, setreqsex] = useState((query?.gender*1 === 1 ? '남' : '여'));   
    const [reqphpone, setreqphpone] = useState(query?.phone);   

    const [termlist, setconfigs] = useState(configdata?.consts?.termTypeConsts);   
    const [agreeall, setagreeall] = useState(false);   
    const [agreesellArr, setagreesellArr] = useState([]);   
    const [okresultData, setokresultData] = useState({});   

    const [agree1, setagree1] = useState(false);   
    const [agree2, setagree2] = useState(false);   
    const [agree3, setagree3] = useState(false);   
    const [agree4, setagree4] = useState(false);   
    const [agree5, setagree5] = useState(false);   
    const [agree6, setagree6] = useState(false);   
    const [submitflag, setsubmitflag] = useState(false);   

    useEffect(() => {
        let agreeArr = [];
        for(let i = 0; i < termlist?.length; i++){
            agreeArr.push(false);
        }
        console.log(agreeArr)
        setagreesellArr(agreeArr);
    }, []);
    useEffect(() => {
        let agreeArr2 = [];
        agreesellArr?.map((x, i) => {
            if(x === true){
                agreeArr2.push(true);
            }
        });
        
        if(agreeArr2?.length === agreesellArr?.length){
            setsubmitflag(true);
        } else {
            setsubmitflag(false);
        }
        if(agree1 && agree2 && agree3 && agree4 && agree5){
            setsubmitflag(true);
        } else {
            setsubmitflag(false);
        }
    }, [agreesellArr, agree1, agree2, agree3, agree4, agree5, agree6]);


    useEffect(() => {
        const script = document.createElement('script');
        const callBackFunc = document.createTextNode(
            "function result(result) {" +
                "try {" +
                    "result = JSON.parse(result);" +
                    "window.location.href='/Register?name='+result?.data+'&phone='+result?.phone+'&gender='+result?.gender+'';" +
                "} catch (error) {" +
                "}" +
            "}");
        script.appendChild(callBackFunc);
        document.body.appendChild(script);
    }, []);
    const mok_popup = () => {
        window.MOBILEOK.process("https://api.maemul.net/mok_std_request", "WB", "result");
    }

    return(
        <Layout header={false}>
            <div className='normalform'>
                <div className='normalform_title'>회원가입</div>
                <div className='normalform_comment2' style={{ textAlign: 'center' }}>모두의매물 이용을 위해서 본인 인증이 필요합니다.</div>
                <div className='normalform_comment2' style={{ textAlign: 'center', marginTop: 20 }}>모두의 매물은 1인 1계정만 이용이 가능합니다.</div>

                 
                {/* <div className='normalform_comment' style={{ marginTop: 40 }}>서비스 이용을 위해 본인인증이 필요합니다.</div> */}
                <div className='loginbutton' style={{ marginTop: 30}}>
                    <Button
                        disabled={false}
                        buttonTxt={'본인인증'}
                        onPress={() => {
                            mok_popup();
                        }}
                    />
                </div>     
            </div>
        </Layout>
    )
}

